import {
    Chart, Coordinate, Axis, Tooltip, Interaction, Interval, Guide, View, Coord, Geom
} from 'bizcharts';
import { Text } from 'bizcharts/lib/g-components';
import numeral from 'numeral';
import React, { useEffect, useState } from 'react'
import { Accordion, Dropdown, Form, Icon, Menu, Segment } from 'semantic-ui-react';
import { InicioMobileAsync, ObtenerLibrosAsync } from '../Servicios/ServiciosPublicos';
import DataSet from "@antv/data-set";
import { RowRender } from '../Controles/RowRender';
import { PrincipalDesktopInicio } from './PrincipalDesktopInicio';
import { PrinciapalDesktopConfig } from './PrinciapalDesktopConfig';
import { PrincipalDesktopOrdenes } from './PrincipalDesktopOrdenes';

export const PrincipalDesktop = () => {

    const [internalState, setInternalState] = useState({
        Libros: [],
        ActiveIndex: 0,
        CongifIndex: 0,
    })
    useEffect(() => { Load(); }, [])
    const Load = async () => {
        await ObtenerLibros();
    }
    const ObtenerLibros = async () => {
        let _libros = await ObtenerLibrosAsync();
        setInternalState((state) => ({ ...state, Libros: _libros }));
    }

    return (
        <div className="bitso-desktop">
            <Menu inverted>
                <Dropdown text={"Ultimos Precios..."} pointing className='link item'>
                    <Dropdown.Menu inverted>
                        {
                            internalState.Libros.map(libro => (
                                <Dropdown.Item>
                                    <div className="div-ultimos-precios-item">
                                        <div>{libro.book.replace("_mxn", "")}</div>
                                        <div>{numeral(+libro.last).format("0,000.00")}</div>
                                    </div>
                                </Dropdown.Item>
                            ))
                        }
                    </Dropdown.Menu>
                </Dropdown>
                <Menu.Item
                    name='Inicio'
                    active={internalState.ActiveIndex === 0}
                    onClick={() => { setInternalState((state) => ({ ...state, ActiveIndex: 0 })); }}
                >
                    <Icon name="home" />
                </Menu.Item>
                <Menu.Item
                    name='Inicio'
                    active={internalState.ActiveIndex === 1}
                    onClick={() => { setInternalState((state) => ({ ...state, ActiveIndex: 1 })); }}
                >
                    <Icon name="sort amount down" />
                </Menu.Item>

                <Menu.Item
                    name='Configuracion'
                    active={internalState.ActiveIndex === 99}
                    position='right'
                    onClick={() => { setInternalState((state) => ({ ...state, ActiveIndex: 99 })); }}
                >
                    <Icon name="cogs" />
                </Menu.Item>
            </Menu>
            {internalState.ActiveIndex === 0 && (<PrincipalDesktopInicio />)}
            {internalState.ActiveIndex === 1 && (<PrincipalDesktopOrdenes />)}
            {internalState.ActiveIndex === 99 && (<PrinciapalDesktopConfig />)}
        </div>
    )
}
